import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { TileHeader, TileComment, Tile } from '../common/Tile';
import Loading, { LoadingWrapper } from '../common/Loading';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
export default function OrganizationsTileUI(props) {
    var twoFirst = props.organizations.slice(0, 2);
    var hasOrganizations = props.organizations.length !== 0;
    var comment = hasOrganizations
        ? 'Companies you are a founder, co-founder or team member in.'
        : 'Here you will be able to see all the companies you are a founder, co-founder or team member in.';
    var header = 'My Companies';
    var loading = props.loading;
    if (loading) {
        return (_jsx(_Fragment, { children: _jsxs(Tile, { children: [_jsx(TileHeader, { children: header }, void 0),
                    _jsx(LoadingWrapper, { children: _jsx(Loading, {}, void 0) }, void 0)] }, void 0) }, void 0));
    }
    return (_jsx(_Fragment, { children: _jsxs(Tile, { children: [_jsx(TileHeader, { children: header }, void 0),
                _jsx(TileComment, { children: comment }, void 0),
                _jsxs(List, { children: [twoFirst.map(function (_a) {
                            var name = _a.name, id = _a.id;
                            return (_jsx(ListItem, { primary: name, chevron: true, onClick: function () { return props.organizationClick(id); } }, id));
                        }),
                        _jsx(ListItem, { primary: hasOrganizations ? 'Show all companies' : 'Create a company', chevron: true, onClick: props.organizationsClick }, void 0)] }, void 0)] }, void 0) }, void 0));
}
//# sourceMappingURL=OrganizationsTileUI.js.map